import { Container } from "react-bootstrap";
import { useQuery } from "@tanstack/react-query";
import clsx from "clsx";
import EPaymentTable from "./components/EPaymentTable";
import PAGE from "../../utils/Destination";
import _ from "lodash";
import { useHistory } from "react-router";
import { React, useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../selectors/auth";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import * as paymentActions from "../../action/payment";
import * as userSelectors from "../../selectors/user";
import * as depositSelectors from "../../selectors/e-deposit";
import {getPaymentIsOperate, getPaymentIsOperateCutOffTime} from "../../selectors/payment";
import * as paymentSelectors from "../../selectors/payment";
import { withPaymentConfig} from "../../hooks/withPaymentConfig";
import { Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faWarning } from "@fortawesome/free-solid-svg-icons";
import GeneralPaymentDisclaimerRemark from "./GeneralPaymentDisclaimerRemark";

function EPayment(paymentConfig) {
  const [token, setToken] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [depositAmount, setDepositAmount] = useState(0);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const selectedCurrency = useSelector((state) =>
    userSelectors.getUserAccountCurrencySelectedObject(state.user),
  );
  const dispatch = useDispatch();
  const [partAmt, setPartAmt] = useState(null);

  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const history = useHistory();
  const search = history?.location?.search;
  const { isLoading, data } = useQuery({
    queryKey: ["e-payment-data"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/payment/outstanding${search}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });
  const epaymentData = _.get(data, ["data"], []);
  const paymentConfigData = _.get(paymentConfig, ["paymentConfig"], []);

  const isOperatePayment = paymentSelectors.getPaymentIsOperate(paymentConfigData);
  const isOperatePaymentCutOff = paymentSelectors.getPaymentIsOperateCutOffTime(paymentConfigData);


  const getTotalAmount = (partAmtData) => {
    const debit = _.map(partAmtData, (item, index) => {
      return _.floor(item.total, 2);
    });
    return _.isNaN(_.sum(debit)) ? 0 : _.sum(debit);
  };

  const totalValue = useMemo(() => getTotalAmount(partAmt), [partAmt]);
  const onClickNavigate = (e, page) => {
    e.preventDefault();
    const result = _.map(partAmt, (item, index) => {
      if (item.total != 0) {
        return {
          data: { ...epaymentData[index] },
          subTotal: item.total,
        };
      }
    });

    dispatch(
      paymentActions.setPaymentAmount({
        items: _.compact(result),
        total: _.ceil(totalValue,2),
        totalAmount: _.ceil(Number(totalValue) + Number(depositAmount),2),
        currency: selectedCurrency,
      }),
    );
    history.push(page);
  };

  return (
    <Container fluid>
      {!isOperatePayment ? (
          <Alert key="info" variant="secondary" sx={{ borderRadius: "5px" }}>
            <div style={{ color: "#2c2c2c" }}>
              <span className={"text-bold-600"}>
                <FontAwesomeIcon
                    icon={faCircleExclamation}
                    color="#2c2c2c"
                    size="xl"
                    style={{ marginRight: 10 }}
                ></FontAwesomeIcon>
                {`Our facility temporary was not available now.`}
              </span>
            </div>
          </Alert>
      ) : (
          false
      )}
      <div className={"primary-border-table-border"}>
        <div className={clsx("custom-card-label-container")}>
          <div className={clsx("d-flex")}>
            <div>
              <h2>{userSelectors.getUserAccountText(selectedCurrency)}</h2>
            </div>
            <div className={clsx("d-flex justify-content-center flex-fill")}>
              <h2>Payment</h2>
            </div>
          </div>
        </div>
        <br />
        <div className={clsx("custom-table-info-container padding-12px")}>
          <EPaymentTable
              setDepositAmount={setDepositAmount}
              depositAmount={depositAmount}
              selectedCurrency={selectedCurrency}
              loading={isLoading}
              totalAmount={totalAmount}
              setTotalAmount={setTotalAmount}
              data={epaymentData}
              totalValue={totalValue}
              partAmt={partAmt}
              setPartAmt={setPartAmt}
              isOperatePayment={isOperatePayment}
              isOperatePaymentCutOff={isOperatePaymentCutOff}
          />
          <div className="d-flex justify-content-center py-3">
            {/*<button className={clsx("btn custom-button-back")}  type="submit">*/}
            {/*    Back*/}
            {/*</button>*/}
            <button
                className={clsx("btn custom-button-primary")}
                type="submit"
                disabled={
                    totalValue === 0 ||
                    Number(totalAmount) - Number(totalValue) < 0 ||
                    !isOperatePayment
                }
                style={{ backgroundColor: "#9D7905" }}
                onClick={(e) => onClickNavigate(e, PAGE.PAYMENT_DETAIL)}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <GeneralPaymentDisclaimerRemark></GeneralPaymentDisclaimerRemark>
    </Container>
  );
}

export default withPaymentConfig(EPayment);
